import { Component, OnInit } from "@angular/core";
import { take } from "rxjs/operators";
import { Router } from "@angular/router";

import { Project } from "../interfaces/project";
import { User } from "../interfaces/user";
import { Request } from "../interfaces/request";

import { ProjectsService } from "../services/projects.service";
import { UserService } from "../services/user.service";
import { AuthenticationService } from "../services/authentication.service";
import { RequestService } from "../services/request.service";
import { PlansService } from "../services/plans.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  pageTitle = "Sistema de Gestión de Información";
  projects: object[] = [];
  user: User[];
  arrayProject: Project[] = [];
  request: Request[];
  duration = "";
  type = "";
  days: any;
  option = "grip";

  constructor(
    private projectService: ProjectsService,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private requestService: RequestService,
    private plansService: PlansService,
    private router: Router
  ) {}

  ngOnInit() {
    this.authenticationService.getStatus().subscribe((status) => {
      if (status != null) {
        this.saveActivity(status.uid);
        this.userService
          .getUserById(status.uid)
          .valueChanges()
          .pipe(take(2))
          .subscribe(
            (v) => {
              let activity = v["active"];
              if (activity == 2) {
                const active = {
                  uid: status.uid,
                  value: 0,
                };
                this.userService
                  .setActive(active)
                  .then((a) => {
                    alert(
                      "Varias sesiones abiertas. Por favor vuelve a iniciar sesión"
                    );
                    this.authenticationService.logout();
                    this.router.navigate(["login"]);
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            },
            (error) => {
              console.log(error);
            }
          );
        this.requestService
          .getRequestsForStatus(status.email, "activo")
          .valueChanges()
          .subscribe(
            (data2: object[]) => {
              this.projects = [];
              data2.forEach((project) => {
                const today = new Date();
                const exp = new Date(project["product"].date_expiration);
                const diff = exp.getTime() - today.getTime();
                this.days = Math.round(diff / (1000 * 60 * 60 * 24));
                const product = {
                  pid: project["product"].pid,
                  avatar: project["product"].avatar,
                  name: project["product"].name,
                  description: project["product"].description,
                  endDate: project["product"].date_expiration,
                  diff: this.days,
                };
                this.projects.push(product);
              });
            },
            (error) => {
              console.log(error);
            }
          );
      }
    });
  }
  saveActivity(uid) {
    const newDate = Date.now();
    const activity = {
      uid: uid,
      timestamp: newDate,
    };
    this.userService
      .setActivity(activity)
      .then(() => {})
      .catch((error) => {
        console.log(error);
      });
  }
}
